import { render, staticRenderFns } from "./AddSubjectDialog.vue?vue&type=template&id=769bf878&scoped=true"
import script from "./AddSubjectDialog.ts?vue&type=script&lang=ts&external"
export * from "./AddSubjectDialog.ts?vue&type=script&lang=ts&external"
import style0 from "./add-subject-dialog.scss?vue&type=style&index=0&id=769bf878&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769bf878",
  null
  
)

export default component.exports